



















import Popup from '@/views/organisms/Popup.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import ApiClient from '@/common/api'
import store from '@/store'
import CheckBox from '@/views/atoms/CheckBox.vue'

export default
  components: {
    Popup
    BlueButton
    CheckBox
  }

  data: () ->
    selectedNum: '0'

  created: () ->
    @selectedNum = @defaultNum

  props:
    list:
      type: Array
      default: []
    title:
      type: String
      default: ''
    name:
      type: String
      default: ''
    id:
      type: String
      default: ''
    defaultNum: 
      type: String
      default: ''

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    save_click: () ->
      api = new ApiClient()
      param = 
        id: @id
        [@name]: @selectedNum
      data = await api.post('/fc/save', param)
      store.getters.getPostParam
      if data.errors.length == 0
        @$emit('click')
    showTextCustomBroker: (id) ->
      for row in @list
        if row.id == id
          return row.name
      return '未選択'
    clickItem: (id) ->
      @selectedNum = id
    checked: (id) ->
      return id == @selectedNum
  }
